import React from "react";
import { HiOutlineKey } from "react-icons/hi";
import GenerateAPIKeyModal from "../../../modals/GenerateAPIKeyModal";

const APIKeyTab = ({ userInfo, hasGeneratedKey, handleUpdates }) => {
  return (
    <div className="animate-fadeIn">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-6">API Key Management</h2>
      
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg overflow-hidden">
        <div className="p-6 bg-gradient-to-r from-white to-gray-50 dark:from-gray-800 dark:to-gray-900">
          <div className="flex flex-col gap-6">
            <div className="flex items-center">
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 rounded-lg mr-4 shadow-md">
                <HiOutlineKey className="h-7 w-7 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                  {hasGeneratedKey ? "Manage Your API Key" : "Create Your First API Key"}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {hasGeneratedKey 
                    ? "Your API key provides access to our API endpoints" 
                    : "Generate an API key to get started with our services"
                  }
                </p>
              </div>
            </div>
            
            {hasGeneratedKey ? (
              <div className="bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 rounded-lg p-5">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center">
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300 mr-2">API Key Status</span>
                    <span className="px-2 py-1 text-xs font-medium rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400">Active</span>
                  </div>
                  {/* <span className="text-xs text-gray-500 dark:text-gray-400">Created on {new Date().toLocaleDateString()}</span> */}
                </div>
                
                <div className="flex items-center justify-between mb-5">
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    <span className="font-medium">Note:</span> API keys are only displayed once at generation time for security
                  </div>
                </div>
                
                {/* <div className="flex flex-wrap gap-2 justify-end">
                  <button 
                    className="px-4 py-2 bg-red-50 text-red-700 hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/30 rounded-lg transition-colors duration-200 text-sm font-medium flex items-center"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Revoke Key
                  </button>
                </div> */}
              </div>
            ) : (
              <div className="p-5 bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 rounded-lg flex items-center justify-between">
                <p className="text-gray-600 dark:text-gray-300">
                  You don't have any API key yet. Generate one to access our API endpoints.
                </p>
                <div className="ml-4 flex-shrink-0">
                  <GenerateAPIKeyModal handleUpdates={handleUpdates} />
                </div>
              </div>
            )}
            
            {hasGeneratedKey ? (
              <div className="mt-4 flex justify-center">
                <GenerateAPIKeyModal handleUpdates={handleUpdates} />
              </div>
            ) : null}
          </div>
        </div>
        
        <div className="bg-gray-50 dark:bg-gray-900 p-6 border-t border-gray-200 dark:border-gray-700">
          <h4 className="font-medium text-gray-800 dark:text-white mb-3 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            Important Security Information
          </h4>
          <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600 dark:text-gray-400">
            <li>Your API key grants access to your account and resources.</li>
            <li>Do not share your API key with others or expose it in client-side code.</li>
            <li>Regenerate your key immediately if you suspect it has been compromised.</li>
            <li>All API requests must include your API key for authentication.</li>
            <li>Rate limits and usage quotas apply based on your subscription plan.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default APIKeyTab; 